import { swalWithConfirmAndCancelButtons } from "components/custom/swal"
import moment from "moment"
import React, { useEffect, useState } from "react"
import Loader from "react-loaders"
import { toast } from "react-toastify"
import { Col, Input, Label, Modal, Row } from "reactstrap"
import { isDirty } from "redux-form"
import api from "services/api.service"
import { userService } from "services/user.service"
import colors from "utils/colors"

const SubscriptionModal = ({ isOpen, toggleModal }) => {
  const currentUser = userService.getLoggedInUser()
  const [jobs, setJobs] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [isSaving, setIsSaving] = useState(false)

  useEffect(() => {
    if (isOpen) {
      loadData()
    }
  }, [isOpen])

  const loadData = async () => {
    setIsLoading(true)
    let jobs = await api.getHangfireJobs(currentUser.userID)
    setJobs(jobs)
    setIsLoading(false)
  }

  const save = async () => {
    if (jobs.find(x => x.isDirty || x.isDeleted) != undefined) {
      setIsSaving(true)
      try {
        let tasks = []
        let jobsToUpdate = jobs.filter(x => x.isDirty)
        let jobsToDelete = jobs.filter(x => x.isDeleted)

        jobsToUpdate.forEach(job => {
          tasks.push(async () => {
            return await api.updateHangfireJob(currentUser.userID, job)
          })
        })
        jobsToDelete.forEach(job => {
          tasks.push(async () => {
            return await api.deleteHangfireJob(currentUser.userID, job.jobID)
          })
        })
        if (tasks.length > 0) {
          await Promise.all(tasks.map(task => task()))
        }
        await loadData()
      } catch (e) {
        console.log(e)
      } finally {
        setIsSaving(false)
        toast.success("Subscriptions saved successfully")
      }
    }
  }

  return (
    <Modal
      backdrop="static"
      isOpen={isOpen}
      size="lg"
      toggle={() => {
        toggleModal()
      }}
    >
      <div className="modal-header">
        <h5 className="modal-title mt-0" id="myModalLabel">
          Subscriptions
        </h5>
        <button
          type="button"
          onClick={() => {
            toggleModal()
          }}
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
        {isLoading && (
          <Loader
            type="line-scale-pulse-out"
            color={colors.primary}
            style={{ textAlign: "center" }}
          />
        )}
        {!isLoading && jobs.length == 0 && <p>You have no Subscriptions</p>}
        {!isLoading && jobs.length > 0 && (
          <table
            className="table table-bordered low-padding-table"
            style={{ backgroundColor: "white" }}
          >
            <thead>
              <tr>
                <th style={{ width: "30%" }}>Report</th>
                <th style={{ width: "30%" }}>Frequency</th>
                <th style={{ width: "30%" }}>Day</th>
                <th style={{ width: "10%" }}></th>
              </tr>
            </thead>
            <tbody>
              {jobs
                .filter(x => !x.isDeleted)
                .map((job, index) => (
                  <tr key={index}>
                    <td>{job.entity}</td>
                    <td>
                      <select
                        className="form-control form-select select2 mb-xxl-0"
                        value={job.frequency}
                        onChange={e => {
                          setJobs(
                            jobs.map(x =>
                              x.jobID == job.jobID
                                ? {
                                    ...x,
                                    frequency: e.target.value,
                                    isDirty: true,
                                    day:
                                      e.target.value == 0 || e.target.value == 3
                                        ? null
                                        : 1,
                                  }
                                : x
                            )
                          )
                        }}
                      >
                        <option value="0">Daily</option>
                        <option value="1">Weekly</option>
                        <option value="2">Monthly</option>
                        <option value="3">Quarterly</option>
                      </select>
                    </td>
                    <td>
                      {job.frequency == 1 && (
                        <select
                          className="form-control form-select select2 mb-xxl-0"
                          value={job.day}
                          onChange={e => {
                            setJobs(
                              jobs.map(x =>
                                x.jobID == job.jobID
                                  ? { ...x, day: e.target.value }
                                  : x
                              )
                            )
                          }}
                          style={{ width: "150px" }}
                        >
                          <option value="0">Sunday</option>
                          <option value="1">Monday</option>
                          <option value="2">Tuesday</option>
                          <option value="3">Wednesday</option>
                          <option value="4">Thursday</option>
                          <option value="5">Friday</option>
                          <option value="6">Saturday</option>
                        </select>
                      )}
                      {job.frequency == 2 && (
                        <select
                          className="form-control form-select select2 mb-xxl-0"
                          value={job.day}
                          onChange={e => {
                            setJobs(
                              jobs.map(x =>
                                x.jobID == job.jobID
                                  ? { ...x, day: e.target.value }
                                  : x
                              )
                            )
                          }}
                          style={{ width: "150px" }}
                        >
                          {Array.from(
                            { length: 30 },
                            (_, index) => index + 1
                          ).map(i => (
                            <option key={i} value={i}>
                              {i}
                            </option>
                          ))}
                        </select>
                      )}

                      {(job.frequency == 0 || job.frequency == 3) && "N/A"}
                    </td>
                    <td>
                      <i
                        className="fas fa-trash"
                        style={{ cursor: "pointer", color: "red" }}
                        onClick={() => {
                          setJobs(
                            jobs.map(x =>
                              x.jobID == job.jobID
                                ? { ...x, isDeleted: true }
                                : x
                            )
                          )
                        }}
                      />
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        )}
      </div>

      <div
        className="modal-footer"
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <button
          type="button"
          className="btn btn-outline-secondary"
          onClick={toggleModal}
        >
          Close
        </button>
        <button
          type="button"
          className="btn btn-primary save-user"
          onClick={save}
          disabled={isSaving}
        >
          Save
        </button>
      </div>
    </Modal>
  )
}

export default SubscriptionModal
